export default __webpack_public_path__ + "static/media/Search.7b929147.svg";